module.exports = "/_next/static/images/block4-e00981e74236c3e4823bbeae54031b6a.svg";